export const modalHeadingStyles = {};
